import { connect } from 'react-redux'
import { compose, lifecycle, withHandlers, withState } from 'recompose'
import Penyedia from 'components/publicPages/penyedia'
import { bindActionCreators } from 'redux'
import { ShootTracker } from 'actions/Tracker'
import Cookies from 'js-cookie'

const mapStateToProps = () => ({})

const mapDispatchToProps = (dispatch) => ({
  ShootTracker: bindActionCreators(ShootTracker, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('pageTracker', 'setPageTracker', {}),
  withState('videoTracker', 'setVideoTracker', {}),
  withState('helpCenterTracker', 'setHelpCenterTracker', {}),
  withState('partnerTracker', 'setPartnerTracker', {}),
  withHandlers({
    getPageTracker: (props) => async () => {
      const { setPageTracker } = props
      const previous_page_name = Cookies.get('page_name')
      Cookies.set('page_name', 'MERCHANT_PAGE', {
        path: '',
        sameSite: 'strict',
        secure: true,
      })

      try {
        const res = await props.ShootTracker('visit_page', {
          key: 'previous_page_name',
          value: previous_page_name,
        })
        setPageTracker(res)
      } catch (err) {
        setPageTracker({})
      }
    },
  }),
  withHandlers({
    clickVideo: (props) => async () => {
      const { setVideoTracker } = props
      try {
        const res = await props.ShootTracker('click_video')
        setVideoTracker(res)
      } catch (err) {
        setVideoTracker({})
      }
    },
  }),
  withHandlers({
    clickHelpCenter: (props) => async () => {
      const { setHelpCenterTracker } = props
      try {
        const res = await props.ShootTracker('click_help_center')
        setHelpCenterTracker(res)
      } catch (err) {
        setHelpCenterTracker({})
      }
    },
  }),
  withHandlers({
    clickPartner: (props) => async (marketplace_name, button_name) => {
      const { setPartnerTracker } = props
      try {
        const res = await props.ShootTracker(
          'click_partner',
          {
            key: 'marketplace_name',
            value: marketplace_name,
          },
          {
            key: 'button_name',
            value: button_name,
          },
        )
        setPartnerTracker(res)
      } catch (err) {
        setPartnerTracker({})
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.getPageTracker()
    },
  }),
)(Penyedia)
